/**
 * Angucomplete
 * Autocomplete directive for AngularJS
 * By Daryl Rowland
 */

 // =====================================
 //
 //   auto-complete
 //   使用第三方的 angucomplete.js
 //   updatetime: 2016 / 03 / 09 by @Gray
 //   
 //   新增 (search @custom)
 //     scope dropdownClass        
 //     checkSelect function
 //     scrollBeforeKeyEvent function
 //     bindInputValue function
 //     scope onFocus function
 //   修改 (search templateUrl)
 //     template
 //
 // =====================================

angular.module('angucomplete', [] )
    .directive('angucomplete', function ($parse, $http, $sce, $timeout, $rootScope, $state) {
    return {
        restrict: 'EA',
        scope: {
            "id": "@id",
            "placeholder": "@placeholder",
            "selectedObject": "=selectedobject",
            "url": "@url",
            "dataField": "@datafield",
            "titleField": "@titlefield",
            "descriptionField": "@descriptionfield",
            "imageField": "@imagefield",
            "imageUri": "@imageuri",
            "inputClass": "@inputclass",
            "userPause": "@pause",
            "localData": "=localdata",
            "searchFields": "@searchfields",
            "minLengthUser": "@minlength",
            "matchClass": "@matchclass",
            // @custom
            "dropdownClass": "@dropdownclass",
            "onFocus": "=onFocus",
            "onBlur": "=onBlur"
        },
        // 原始的template
        // template: '<div class="angucomplete-holder"><input id="{{id}}_value" ng-model="searchStr" type="text" placeholder="{{placeholder}}" class="{{inputClass}}" onmouseup="this.select();" ng-focus="resetHideResults()" ng-blur="hideResults()" /><div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown"><div class="angucomplete-searching" ng-show="searching">Searching...</div><div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)">No results found</div><div class="angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}"><div ng-if="imageField" class="angucomplete-image-holder"><img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/><div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div></div><div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div><div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div><div ng-if="result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div></div></div></div>',
        templateUrl: 'js/vendors/angucomplete-master/angucomplete.html',

        link: function($scope, elem, attrs) {
            var isNewSearchNeeded; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError
            $scope.lastSearchTerm = null;
            $scope.currentIndex = null;
            $scope.justChanged = false;
            $scope.searchTimer = null;
            $scope.hideTimer = null;
            $scope.searching = false;
            $scope.pause = 500;
            $scope.minLength = 3;
            $scope.searchStr = null;

            if ($scope.minLengthUser && $scope.minLengthUser != "") {
                $scope.minLength = $scope.minLengthUser;
            }

            if ($scope.userPause) {
                $scope.pause = $scope.userPause;
            }

            isNewSearchNeeded = function(newTerm, oldTerm) {
                return newTerm.length >= $scope.minLength && newTerm != oldTerm
            }

            $scope.processResults = function(responseData, str) {
                if (responseData && responseData.length > 0) {
                    $scope.results = [];

                    var titleFields = [];
                    if ($scope.titleField && $scope.titleField != "") {
                        titleFields = $scope.titleField.split(",");
                    }

                    for (var i = 0; i < responseData.length; i++) {
                        // Get title variables
                        var titleCode = [];

                        for (var t = 0; t < titleFields.length; t++) {
                            titleCode.push(responseData[i][titleFields[t]]);
                        }

                        var description = "";
                        if ($scope.descriptionField) {
                            description = responseData[i][$scope.descriptionField];
                        }

                        var imageUri = "";
                        if ($scope.imageUri) {
                            imageUri = $scope.imageUri;
                        }

                        var image = "";
                        if ($scope.imageField) {
                            image = imageUri + responseData[i][$scope.imageField];
                        }

                        var text = titleCode.join(' ');
                        if ($scope.matchClass) {
                            var re = new RegExp(str, 'i');
                            var strPart = text.match(re)[0];
                            text = $sce.trustAsHtml(text.replace(re, '<span class="'+ $scope.matchClass +'">'+ strPart +'</span>'));
                        }

                        var resultRow = {
                            title: text,
                            description: description,
                            image: image,
                            originalObject: responseData[i]
                        }

                        $scope.results[$scope.results.length] = resultRow;
                    }


                } else {
                    $scope.results = [];
                }
            }

            $scope.searchTimerComplete = function(str) {
                // Begin the search

                if (str.length >= $scope.minLength) {
                    if ($scope.localData) {
                        var searchFields = $scope.searchFields.split(",");

                        var matches = [];

                        for (var i = 0; i < $scope.localData.length; i++) {
                            var match = false;

                            for (var s = 0; s < searchFields.length; s++) {
                                match = match || (typeof $scope.localData[i][searchFields[s]] === 'string' && typeof str === 'string' && $scope.localData[i][searchFields[s]].toLowerCase().indexOf(str.toLowerCase()) >= 0);
                            }

                            if (match) {
                                matches[matches.length] = $scope.localData[i];
                            }
                        }

                        $scope.searching = false;
                        $scope.processResults(matches, str);

                    } else {
                        $http.get($scope.url + str, {}).
                            success(function(responseData, status, headers, config) {
                                $scope.searching = false;
                                $scope.processResults((($scope.dataField) ? responseData[$scope.dataField] : responseData ), str);
                            }).
                            error(function(data, status, headers, config) {
                                console.log("error");
                            });
                    }
                }
            }

            $scope.hideResults = function() {
                $scope.hideTimer = $timeout(function() {
                    $scope.showDropdown = false;
                }, $scope.pause);

                // @custom
                if($scope.onBlur) {
                    $scope.onBlur();
                }
            };

            $scope.resetHideResults = function() {
                if($scope.hideTimer) {
                    $timeout.cancel($scope.hideTimer);
                };

                // @custom
                if($scope.onFocus) {
                    $scope.onFocus();
                }
            };

            $scope.hoverRow = function(index) {
                $scope.currentIndex = index;
            }

            $scope.keyPressed = function(event) {
                if (!(event.which == 38 || event.which == 40 || event.which == 13)) {
                    if (!$scope.searchStr || $scope.searchStr == "") {
                        $scope.showDropdown = false;
                        $scope.lastSearchTerm = null
                    } else if (isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
                        $scope.lastSearchTerm = $scope.searchStr
                        $scope.showDropdown = true;
                        $scope.currentIndex = -1;
                        $scope.results = [];

                        if ($scope.searchTimer) {
                            $timeout.cancel($scope.searchTimer);
                        }

                        $scope.searching = true;
                        scrollBeforeKeyEvent();

                        $scope.searchTimer = $timeout(function() {
                            $scope.searchTimerComplete($scope.searchStr);
                        }, $scope.pause);
                    }
                } else {
                    event.preventDefault();
                }
            }

            $scope.selectResult = function(result) {
                if ($scope.matchClass) {
                    result.title = result.title.toString().replace(/(<([^>]+)>)/ig, '');
                }
                $scope.searchStr = $scope.lastSearchTerm = result.title;
                $scope.selectedObject = result;
                $scope.showDropdown = false;
                $scope.results = [];
                //$scope.$apply();
            }

            // @custom
            var checkSelect = function() {

                if (!$scope.searchStr || $scope.searchStr == "") {
                    $scope.showDropdown = false;
                    $scope.lastSearchTerm = null
                    return;
                } else if(Array.isArray($scope.results) && $scope.results.length > 0){

                    for(var i = 0; i < $scope.results.length; i++) {

                        var result = $scope.results[i];
                        var title;

                        if ($scope.matchClass) {
                            title = result.title.toString().replace(/(<([^>]+)>)/ig, '');
                        }

                        if(title.trim() == $scope.searchStr.trim()) {
                            $scope.selectResult(result);
                            return;
                        }
                    }
                }

                // 沒選到要直接回傳關鍵字
                $scope.selectedObject = {title: $scope.searchStr.trim()};
                $scope.showDropdown = false;
                $scope.results = [];
            }

            // @custom
            var scrollBeforeKeyEvent = function() {
                
                $timeout(function() {

                    var content = $(elem).find('.angucomplete-wrapper');
                    var selected = content.find('.angucomplete-selected-row');

                    if (selected.length > 0) {
                        var position = selected.position();
                        if (position.top < 0) {
                            content.stop().animate({
                                scrollTop: position.top + content.scrollTop()
                            }, 100);
                        } else if (position.top + selected.height() > content.height()) {
                            content.stop().animate({
                                scrollTop: content.scrollTop() + selected.height()
                            }, 100);
                        }
                    } else {
                        content.stop().animate({
                            scrollTop: 0
                        }, 100);
                    }
                })
            }

            // @custom
            $scope.bindInputValue = function() {

                if (!$scope.searchStr || $scope.searchStr == "") {
                    $scope.showDropdown = false;
                    $scope.lastSearchTerm = null
                } else if (isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
                    $scope.lastSearchTerm = $scope.searchStr
                    $scope.showDropdown = true;
                    $scope.currentIndex = -1;
                    $scope.results = [];

                    if ($scope.searchTimer) {
                        $timeout.cancel($scope.searchTimer);
                    }

                    $scope.searching = true;
                    scrollBeforeKeyEvent();

                    $scope.searchTimer = $timeout(function() {
                        $scope.searchTimerComplete($scope.searchStr);
                    }, $scope.pause);
                }
            }

            // 初進頁面若有參數帶進搜尋頁則將搜尋 keyword 填入
            if($state.includes(STATES.SEARCH) && $state.params){
                $scope.searchStr = $state.params.keyword;
            }

            var inputField = elem.find('input');
            //
            $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

                //切換 state
                if (toState && $state.includes(STATES.SEARCH)) {
                    $scope.searchStr = toParams.keyword;
                } else {
                    $scope.searchStr = "";
                    inputField.blur();
                }
            });

            // inputField.on('keyup', $scope.keyPressed);

            elem.on("keydown", function (event) {
                if(event.which === 40) {
                    if ($scope.results && ($scope.currentIndex + 1) < $scope.results.length) {
                        $scope.currentIndex ++;
                        scrollBeforeKeyEvent();
                        $scope.$apply();
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }

                    $scope.$apply();
                } else if(event.which == 38) {
                    if ($scope.currentIndex >= 1) {
                        $scope.currentIndex --;
                        scrollBeforeKeyEvent();
                        $scope.$apply();
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }

                }
            });

            elem.on("keyup", function (event) {
                if(event.which === 40) {
                    // if ($scope.results && ($scope.currentIndex + 1) < $scope.results.length) {
                    //     $scope.currentIndex ++;
                    //     scrollBeforeKeyEvent();
                    //     $scope.$apply();
                    //     event.preventDefault;
                    //     event.stopPropagation();
                    // }

                    // $scope.$apply();
                } else if(event.which == 38) {
                    // if ($scope.currentIndex >= 1) {
                    //     $scope.currentIndex --;
                    //     scrollBeforeKeyEvent();
                    //     $scope.$apply();
                    //     event.preventDefault;
                    //     event.stopPropagation();
                    // }

                } else if (event.which == 27) {
                    $scope.results = [];
                    $scope.showDropdown = false;
                    $scope.$apply();
                } else if (event.which == 8) {
                    $scope.selectedObject = null;
                    $scope.$apply();
                }
            });

            // enter 使用 keypress 來處理中文選字問題
            elem.on("keypress", function(event) {

                if (event.which == 13) {
                    if ($scope.results && $scope.currentIndex >= 0 && $scope.currentIndex < $scope.results.length) {
                        $scope.selectResult($scope.results[$scope.currentIndex]);
                        $scope.$apply();
                        event.preventDefault;
                        event.stopPropagation();
                    } else {
                        // $scope.results = [];
                        checkSelect();
                        $scope.$apply();
                        event.preventDefault;
                        event.stopPropagation();
                    }
                }
            });
        }
    };
});

